import type { ComponentType } from "react";

import { PendingPlanningRow } from "./ToolCallCardPendingPlanningRow";
import {
  isExploreSessionOpen,
  isQueryToolActive,
  isQueryToolCall,
  isThinkToolActive,
  isThinkToolCall,
} from "@/components/organisms/ToolCallCard/ToolCallCard.tools";
import { ToolCallCardChildList } from "./ToolCallCardChildList";
import type { ToolCallContent } from "./ToolCallCard.types";

type ToolCallCardActionThreadProps = {
  item: ToolCallContent;
  depth: number;
  threadIsStreaming?: boolean;
  ToolCallCard: ComponentType<{
    item: ToolCallContent;
    depth?: number;
    threadIsStreaming?: boolean;
  }>;
};

/** Renders agent output nested under a workflow ACTION_THREAD node_eval row. */
export function ToolCallCardActionThread({
  item,
  depth,
  threadIsStreaming = false,
  ToolCallCard,
}: ToolCallCardActionThreadProps) {
  const output = item.toolOutput as Record<string, unknown> | null | undefined;
  const isRunning = output?.status === "running";
  const children = item.children ?? [];
  // Planning shows only when nothing else in the node is mid-step.
  const hasActiveChild = children.some(
    (child) => isThinkToolActive(child) || isQueryToolActive(child),
  );
  const showPlanning =
    threadIsStreaming &&
    isRunning &&
    !hasActiveChild &&
    (children.length === 0 ||
      !!(
        children[children.length - 1]?.toolOutput ||
        children[children.length - 1]?.toolError
      ));

  return (
    <div className="w-full mt-1 mb-1 max-w-full">
      <ToolCallCardChildList
        children={item.children}
        depth={depth}
        threadIsStreaming={threadIsStreaming}
        workflowRunning={isRunning}
        ToolCallCard={ToolCallCard}
      />
      {showPlanning && <PendingPlanningRow />}
    </div>
  );
}
